export default (v, previousValue) => {

  const newValue = v.replace(/[^\d]/g, '').toString().substring(0, 11)
  .replace(/(\d{3})(\d)/, '$1.$2')
  .replace(/(\d{3})(\d)/, '$1.$2')
  .replace(/(\d{3})(\d)/, '$1.$2')

  return newValue;

};



// WEBPACK FOOTER //
// ./src/components/normalize/CPFNormalize.js